import ElementUiEnLocale from "element-ui/lib/locale/lang/en";
import merge from "deepmerge";

const messages = {
  // elementUI
  el: {
    transfer: {
      noMatch: "No results",
      noData: ""
    },
    table: {
      emptyText: "Nothing to show",
      confirmFilter: "Confirm",
      resetFilter: "Reset",
      clearFilter: "All",
      sumText: "Sum"
    }
  },
  scenes: {
    auth: {
      oPasswordValidation: {
        m_strErrEmpty: `Password cannot be empty`,
        m_strErrConditions: `Too weak. Requires 6 characters (upper & lowercase letters, numbers & special characters)`,
        m_strErrRejectPwds: `Sorry but that password is not accepted`,
        m_strErrorPwdsNotSame: "Your passwords do not match"
      },
      register: {
        userForm: {
          firstName: "First name",
          lastName: "Surname",
          userId: "Email Address",
          password: "Password",
          passwordConfirmation: "Confirm password",
          createAccount: "Create account"
        },
        formErrors: {
          firstName: "Please enter your name",
          lastName: "Please enter your surname",
          userId: {
            required: "Please enter your email address",
            valid: "Please enter a valid email address"
          },
          password: {
            required: "Please enter your password"
          }
        }
      },
      login: {
        footer: {
          poweredBy: "Powered by",
          help: "Support",
          m_strMementoYearbook: "Memento Yearbook",
          m_strMementoPix: "MementoPix",
          status: "Status"
        },
        userForm: {
          firstName: "First name",
          lastName: "Surname",
          userId: "Email Address",
          password: "Password",
          passwordConfirmation: "Confirm password",
          rememberMe: "Remember me",
          signIn: "Sign in",
          forgottenPassword: "Forgotten your password?"
        },
        formErrors: {
          firstName: "Please enter your name",
          lastName: "Please enter your surname",
          userId: {
            required: "Please enter your email address",
            valid: "Please enter a valid email address"
          },
          password: {
            required: "Please enter your password"
          }
        },
        errors: {
          AUTH_ERROR: {
            title: "Incorrect credentials",
            message: "The password you entered is incorrect. Please try again"
          }
        }
      }
    },
    checkout: {
      address: {
        form: {
          name: "Full name",
          email: "Email address",
          address_line_1: "Address",
          address_line_2: "Apt, suite, etc (optional)",
          address_city: "City",
          address_state: "State",
          address_zip: "Zip",
          address_country: "Country"
        },
        formErrors: {
          email: {
            required: "Please enter your email address",
            valid: "Please enter a valid email address"
          }
        }
      }
    }
  },
  ok: "Ok",
  yes: "Yes",
  no: "No",
  or: "Or",
  cancel: "Cancel",
  dang: "Dang",
  close: "Close",
  delete: "Delete",
  deleted: "Deleted",
  back: "Back",
  next: "Next",
  move: "Move",
  import: "Import",
  moved: "Moved",
  imported: "Imported",
  from: "From",
  save: "Save",
  error: "Error",
  edit: "Edit",
  review: "Review",
  reject: "Reject",
  approve: "Approve",
  note: "Note",
  page: "page | pages",
  people: "person | people",
  do: "does | do",
  is: "is | are",
  photo: "photo | photos",
  day: "day | days",
  notStarted: "Not started",
  tryAgain: "Please try again",
  loading: "Loading...",
  kid: "kid | kids",
  m_strUpdate: "update",
  m_strDontCancel: `Don't cancel the import`,
  m_strDoCancel: `Yes, cancel the import`
};

export default merge(ElementUiEnLocale, messages);
